import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "job-options-dropdown" }
const _hoisted_2 = { class: "job-options-dropdown__item-text" }
const _hoisted_3 = { class: "job-options-dropdown__item-text" }
const _hoisted_4 = { class: "job-options-dropdown__item-text" }
const _hoisted_5 = {
  key: 3,
  class: "job-options-dropdown__divider"
}
const _hoisted_6 = { class: "job-options-dropdown__item-text" }
const _hoisted_7 = { class: "job-options-dropdown__item-text" }
const _hoisted_8 = { class: "job-options-dropdown__item-text" }
const _hoisted_9 = { class: "job-options-dropdown__item-text" }
const _hoisted_10 = { class: "job-options-dropdown__item-text" }
const _hoisted_11 = { class: "job-options-dropdown__item-text" }
const _hoisted_12 = {
  key: 10,
  class: "job-options-dropdown__divider"
}
const _hoisted_13 = { class: "job-options-dropdown__item-text" }
const _hoisted_14 = { class: "job-options-dropdown__item-text" }
const _hoisted_15 = { class: "job-options-dropdown__item-text" }
const _hoisted_16 = { class: "job-options-dropdown__item-text" }

import {computed, ref} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import {Job} from "@/store/jobs";
import {copyTextToClipboard} from "@/utils/clipboard";
import {buildAbsoluteClientUrl} from "@/utils/urlHelpers";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobsOptionsDropdown',
  props: {
    job: {},
    showSendToChecking: { type: Boolean },
    showEndByWorker: { type: Boolean },
    showEndByWorkerWithMessage: { type: Boolean },
    showEndByCreator: { type: Boolean },
    showSendToReworking: { type: Boolean },
    showEndByAdmin: { type: Boolean },
    showEdit: { type: Boolean },
    showDelete: { type: Boolean }
  },
  emits: ["on-show-info", "on-edit", "on-delete", "on-create-linked", "on-show-linked", "on-comment", "on-send-to-checking", "on-end-by-worker", "on-end-by-worker-with-message", "on-end-by-creator", "on-send-to-reworking", "on-end-by-admin"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Верхняя секция (связанные работы, комментировать)
const hasTopActions = computed(() => false)

// Видимость разделителя между статус-действиями и остальным меню
const hasStatusActions = computed(() =>
	props.showSendToReworking
	|| props.showEndByWorker
	|| props.showEndByCreator
	|| props.showEndByWorkerWithMessage
	|| props.showEndByAdmin
	|| props.showSendToChecking
)

const $tooltip = ref<typeof AppTooltip | null>(null)

const onCopyLink = async () => {
	let target: { page: string; id: number } | null = null
	if (props.job.Project) {
		target = { page: 'project', id: props.job.Project.Id }
	} else if (props.job.Clients?.[0]) {
		target = { page: 'client', id: props.job.Clients[0].Id }
	}

	if (!target) {
		return
	}

	const copied = await copyTextToClipboard(
		buildAbsoluteClientUrl(`main?page=${target.page}&id=${target.id}&jobId=${props.job.Id}`)
	)
	if (!copied) {
		return
	}

	$tooltip.value?.showByClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "job-options-dropdown__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-create-linked')))
        }, [
          _createVNode(AppIcon, {
            name: "create-related-work",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('job_create_related')), 1)
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "job-options-dropdown__item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('on-show-linked')))
        }, [
          _createVNode(AppIcon, {
            name: "related",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('job_show_related')), 1)
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "job-options-dropdown__item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('on-comment')))
        }, [
          _createVNode(AppIcon, {
            name: "comment-arrow",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('job_comment_action')), 1)
        ]))
      : _createCommentVNode("", true),
    (hasTopActions.value && hasStatusActions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.showSendToReworking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "job-options-dropdown__item job-options-dropdown__item--warning",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('on-send-to-reworking')))
        }, [
          _createVNode(AppIcon, {
            name: "back-to-rework",
            width: "18px",
            color: "#F9C22F"
          }),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('job_action_return_to_rework')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByWorker)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "job-options-dropdown__item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('on-end-by-worker')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#607D8B"
          }),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('job_action_finish')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByCreator)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "job-options-dropdown__item",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('on-end-by-creator')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#607D8B"
          }),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('job_action_accept')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByWorkerWithMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "job-options-dropdown__item",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('on-end-by-worker-with-message')))
        }, [
          _createVNode(AppIcon, {
            name: "check-circle",
            width: "18px",
            color: "#607D8B"
          }),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('job_action_finish_with_report')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEndByAdmin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          class: "job-options-dropdown__item",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('on-end-by-admin')))
        }, [
          _createVNode(AppIcon, {
            name: "end-by-admin",
            width: "18px",
            color: "#607D8B"
          }),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('job_action_finish_as_admin')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSendToChecking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 9,
          class: "job-options-dropdown__item job-options-dropdown__item--warning",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('on-send-to-checking')))
        }, [
          _createVNode(AppIcon, {
            name: "send-to-check",
            width: "18px",
            color: "#F9C22F"
          }),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('job_action_send_to_checking')), 1)
        ]))
      : _createCommentVNode("", true),
    (hasStatusActions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
      : _createCommentVNode("", true),
    _createVNode(AppTooltip, {
      ref_key: "$tooltip",
      ref: $tooltip,
      class: "job-options-dropdown__share-tooltip",
      text: _ctx.$t('link_copied_to_clipboard'),
      position: "right",
      "show-by-activator-click": ""
    }, {
      activator: _withCtx(() => [
        _createElementVNode("div", {
          class: "job-options-dropdown__item",
          onClick: onCopyLink
        }, [
          _createVNode(AppIcon, {
            name: "share",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('ui_share_link')), 1)
        ])
      ]),
      _: 1
    }, 8, ["text"]),
    _createElementVNode("div", {
      class: "job-options-dropdown__item",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('on-show-info')))
    }, [
      _createVNode(AppIcon, {
        name: "info-circle-outline",
        width: "18px",
        color: "#979797"
      }),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('ui_view_info')), 1)
    ]),
    (_ctx.showEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 11,
          class: "job-options-dropdown__item",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('on-edit')))
        }, [
          _createVNode(AppIcon, {
            name: "edit-square-outline",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('job_edit')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDelete)
      ? (_openBlock(), _createElementBlock("div", {
          key: 12,
          class: "job-options-dropdown__item",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('on-delete')))
        }, [
          _createVNode(AppIcon, {
            name: "delete-outline",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('job_delete')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})